export const initialState = {
  eventId: '',
  eventInstanceId: '',
  providerTimezone: '',
  selectedTimezone: ''
};
